import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Select as SelectAntd } from 'antd'

const StyledSelect = styled(SelectAntd)`
  font-family: Roboto;
  & > .ant-select > .ant-select-selection,
  & .ant-select-selector,
  & .ant-select-selector:focus,
  & > .ant-select > .ant-select-selection:focus,
  & > .ant-select > .ant-select-selection:active {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }
  .ant-select-selection-selected-value {
    font-weight: normal;
  }
  & .ant-select-item-option-content {
    color: rgb(178, 179, 178);
    font-weight: 600;
  }
  .ant-select-selection-item {
    color: rgba(0, 0, 0, 0.65) !important;
  }

  & .ant-select-item-option-selected > div {
    color: rgba(0, 0, 0, 0.65) !important;
    font-weight: 900;
  }

  & input {
    color: rgb(178, 179, 178);
    font-weight: 600;
  }
`

const Select = ({ style, children, ...props }) => {
  return (
    <StyledSelect {...props} style={{ width: '100%', ...style }} getPopupContainer={trigger => trigger.parentNode}>
      {children}
    </StyledSelect>
  )
}

Select.propTypes = {
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.shape({})
}

Select.defaultProps = {
  children: null,
  style: {}
}

export default Select
